
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.206 8.931l-5.625 5.312c-.593.56-1.581.145-1.581-.681V10.75c-5.648.038-8.03 1.371-6.437 6.693.176.585-.501 1.038-.976.677-1.522-1.156-2.9-3.368-2.9-5.6 0-5.623 4.594-6.738 10.313-6.77V2.938c0-.827.989-1.241 1.581-.682l5.625 5.312a.938.938 0 010 1.363zM16 16.81v2.69H3.5V7h1.989a.468.468 0 00.338-.144 7.615 7.615 0 011.992-1.472c.435-.227.274-.884-.216-.884H2.875C1.839 4.5 1 5.34 1 6.375v13.75C1 21.16 1.84 22 2.875 22h13.75c1.035 0 1.875-.84 1.875-1.875v-3.47c0-.323-.32-.549-.625-.44a2.805 2.805 0 01-1.336.131.47.47 0 00-.539.463z","fill":"#282E3E"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1 2)","d":"M0 0h22.5v20H0z"}})])])])
          )
        }
      }
    